import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=d74d3a28&scoped=true&"
import script from "./FieldLabel.vue?vue&type=script&lang=js&"
export * from "./FieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74d3a28",
  null
  
)

export default component.exports